import * as Yup from "yup";
import {FIELD_REQUIRED, FIELD_STRING,} from "../../../../common/constants/validationErrors";

import * as loginFormNames from "./loginFormNames";

export const loginValidationSchema = Yup.object().shape({
  [loginFormNames.LOGIN_USERNAME_FORM_NAME]: Yup.string()
    .typeError(FIELD_STRING)
    .required(FIELD_REQUIRED),
  [loginFormNames.LOGIN_SECRET_FORM_NAME]: Yup.string()
    .typeError(FIELD_STRING)
    .required(FIELD_REQUIRED),
});
